// extracted by mini-css-extract-plugin
export var grid = "fp-3m";
export var gridWithRowGap = "fp-4m";
export var maxWidthContainer = "fp-8m";
export var mt0 = "fp-Xm";
export var mt1 = "fp-Ym";
export var mt2 = "fp-Zm";
export var mt3 = "fp-_m";
export var mt4 = "fp--m";
export var mt5 = "fp-0m";
export var mt6 = "fp-1m";
export var removeVisuallyHidden = "fp-6m";
export var searchInput__closeBtn = "fp-2m";
export var searchInput__closeIcon = "fp-cn";
export var searchInput__input = "fp-an";
export var searchInput__inputWrapper = "fp-9m";
export var searchInput__searchBtn = "fp-bn";
export var visuallyHidden = "fp-5m";
export var widgetBase = "fp-7m";